/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { GetRicaricaView } from './getRicaricaView';

/**
 * Risposta contenente le ricariche e le statistiche per anno dell'annualità
 */
export interface GetRicaricheResponseDTO { 
    /**
     * Lista delle ricariche dello studente
     */
    ricariche?: Array<GetRicaricaView>;
    /**
     * Somma dei pagamenti del primo anno dell'annualità (es. 2024 per annualità 2024/2025)
     */
    sommaPagamentiPrimoAnno?: number;
    /**
     * Somma dei pagamenti del secondo anno dell'annualità (es. 2025 per annualità 2024/2025)
     */
    sommaPagamentiSecondoAnno?: number;
    /**
     * Primo anno dell'annualità (es. 2024 per annualità 2024/2025)
     */
    primoAnno?: number;
    /**
     * Secondo anno dell'annualità (es. 2025 per annualità 2024/2025)
     */
    secondoAnno?: number;
}